import { warehouseEarlyHourQuery } from 'domains/shifts/components/queries/warehouseEarlyHourQuery'
import { toInteger } from 'utils/parsing/numbers'

interface Props {
  warehouseId: string
}

// Return type of the function
export interface WarehouseEarlyPickingHour {
  warehouseId: string
  earlyHour: number
}

export const fetchEarlyHoursForWarehouse = async ({
  warehouseId: targetId,
}: Props): Promise<WarehouseEarlyPickingHour | undefined> => {
  const response = await warehouseEarlyHourQuery({ warehouseId: toInteger(targetId) })

  const earlyHour = response.warehouse.earlyPickingHour

  if (earlyHour) {
    return {
      warehouseId: targetId,
      earlyHour,
    }
  }

  return undefined
}
